import React, { useContext, useState, useEffect } from "react"
import {
    FilteredCoursesTitle,
    TagsContainer,
    CourseTag,
    ExpandFilters,
    MenuGrid,
    MenuOverlay,
    MenuContainer,
    MenuContent,
    CloseButton,
    CloseChevron,
    CloseButtonContainer,
    ApplyFiltersContainer,
    NewTagCategory,
    MobileFilterMenu
} from "./course-filter.style"

import { filterData } from "./options-data"
import MobileContext from "../../providers/mobile/mobile.provider"
import dataLayerHelper from "../../helpers/datalayer.helper"
import { VerticalExplorerContainer, CategoryContainer, VerticalH3, VerticalTopicLink, FormatContainer, ChevronContainer, ExpandFiltersButton } from "../blog-newsletter-explorer/blog-newsletter-explorer.styles"
import BlogSidebarContext from "../../providers/blog-sidebar/blog-sidebar.provide"
import Chevron from "../../svg/Chevron.svg"
import Filter from "../../svg/Filter.svg"

const CourseFilter = ({
    courseFilter,
    setCourseFilter,
    options,
    selectedCategory,
    setSelectedCategory,
    selectedFormat,
    setSelectedFormat,
    selectedLevel,
    setSelectedLevel,
    selectedSubcategory,
    setSelectedSubcategory,
    isExpanded,
    setIsExpanded,
    setQuery,
    hasQueryParams,
    setQueryParams,
    resetSearch,
    clearSearch }) => {

    if (hasQueryParams?.category) {
        if (hasQueryParams.category === "ai_machine_learning") setSelectedCategory("data_and_machine_learning")
        else if (hasQueryParams.category === "web3_blockchain") setSelectedCategory("web3_and_blockchain")
        else if (hasQueryParams.category === "cloud_devops") setSelectedCategory("cloud_and_devops")
        else if (hasQueryParams.category === "business_data") setSelectedCategory("business")
        else setSelectedCategory(hasQueryParams.category)
    }
    if (hasQueryParams?.format) setSelectedFormat(hasQueryParams.format)

    const { formatTag } = courseFilter
    const { categories: cat1, } = filterData
    const { isMobile } = useContext(MobileContext)
    const { isFormatOpen, isTopicOpen, isSubtopicOpen, isCourseLevelOpen, toggleFormat, toggleTopic, toggleSubtopic, toggleCourseLevel } =
        useContext(BlogSidebarContext)

    let categories = cat1
    if (options) categories = options

    const availableFormats = [
        {
            value: "all",
            label: "All Formats",
        },
        {
            value: "bootcamp",
            label: "Bootcamp",
        },
        {
            value: "byte",
            label: "Byte",
        },
        {
            value: "project",
            label: "Project",
        },
    ]

    // handles queryParams reset
    const handleQueryParamReset = () => {
        setQueryParams(false)
        window && window.history.pushState("", "", '/courses')
    }

    const [isCategoryClicked, setIsCategoryClicked] = useState(false)

    useEffect(() => {
        if (hasQueryParams?.category) setIsCategoryClicked(true)
    }, [hasQueryParams])

    const [showButton, setShowButton] = useState(false)
    const [isCloseButtonActive, setIsCloseButtonActive] = useState(false)
    const [isVisible, setIsVisible] = useState(false);

    const handleShow = () => {
        setIsVisible(true);
    };

    const handleHide = () => {
        setIsVisible(false);
    };

    const handleCategoryClick = (category) => {
        resetSearch()
        setSelectedCategory(category.value)
        onCourseTagClick(category)
        activateSubcategory(category)
        handleQueryParamReset()
        setQuery("")
    }

    const activateSubcategory = (category) => {
        if (category.value !== "all") {
            setIsCategoryClicked(true)
        } else {
            setIsCategoryClicked(false)
        }
        setQuery("")
    }

    const onCourseTagClick = (category) => {
        setCourseFilter({
            primaryTag: category.value,
            sortByValue: "most_popular",
            secondaryTag: "all",
            formatTag: "all",
            showResult: true,
            tag_slug: category.tag_slug,
        })
        dataLayerHelper({
            event: "coursePageFilter",
            action: "Categories",
            label: category.label,
            // Has to be categoty.value! courseFilter is not updated at the time this is executed.
            primaryTag: category.value,
            secondaryTag: courseFilter.secondaryTag,
            formatTag: courseFilter.formatTag,
            sortBy: courseFilter.sortByValue,
        })
        setSelectedFormat("all")
        setSelectedLevel("all")
        setQuery("")
        handleQueryParamReset()
    }

    const onSubcategoryChange = (subcategory) => {
        setCourseFilter({
            ...courseFilter,
            subcategoryTag: subcategory.value,
            showFilter: true,
            showResult: true,
            sortByValue: "most_popular",

        })
        setSelectedSubcategory(subcategory.value)
        setQuery("")
        handleQueryParamReset()
    }

    const onFormatChange = (format) => {
        clearSearch()
        setCourseFilter({
            ...courseFilter,
            formatTag: format.value,
            // format change causing subcategory to display after reset on all categories if a subcategory was selected
            //subcategoryTag: null,
            showFilter: true,
            showResult: true,
            sortByValue: "most_popular",
        })
        setSelectedFormat(format.value)
        setQuery("")
        handleQueryParamReset()

        if (selectedCategory !== "all" && categories[selectedCategory]?.label_options?.length > 1) {
            setIsCategoryClicked(true);
        } else {
            setIsCategoryClicked(false);
        }
    }

    const onTopicChange = (category) => {
        clearSearch()
        setCourseFilter({
            ...courseFilter,
            secondaryTag: category.value,
            showFilter: true,
            showResult: true,
            sortByValue: "most_popular",
        })
        dataLayerHelper({
            event: "coursePageFilter",
            action: "Topics",
            label: category.label,
            primaryTag: courseFilter.primaryTag,
            // Has to be option.value! courseFilter is not updated at the time this is executed.
            // Updated to category.value to incorporate new functionality for the courses page -- course level selections now need to persist when the onCourseTagClick is selected
            secondaryTag: category.value,
            formatTag: formatTag.value,
            sortBy: courseFilter.sortByValue,
        })
        setSelectedLevel(category.value)
        setQuery("")
        handleQueryParamReset()
        if (selectedCategory !== "all" && categories[selectedCategory]?.label_options?.length > 1) {
            setIsCategoryClicked(true);
        } else {
            setIsCategoryClicked(false);
        }
    }

    const handleTagClick = (category) => {
        onCourseTagClick(category)
        activateSubcategory(category)
        handleCategoryClick(category)
        setQuery("")
        setSelectedSubcategory("all")
    }


    // Handles Mobile Menus
    useEffect(() => {
        setShowButton(window.innerWidth <= 780)
        setIsExpanded(!(window.innerWidth <= 780))
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const handleResize = () => {
            setShowButton(window.innerWidth <= 780);
        };

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        const handleExpandOnResize = () => {
            if (window.innerWidth > 780) {
                setIsExpanded(true)
            }
        }
        window.addEventListener("resize", handleExpandOnResize)

        return () => {
            window.removeEventListener("resize", handleExpandOnResize)
        }
        // eslint-disable-next-line
    }, [])

    useEffect(() => {
        // Function to close the menu when a link is clicked
        const handleLinkClick = () => {
            if (window.innerWidth <= 780) {
                setIsExpanded(false)
            }
        }

        // Add event listeners to all links
        const links = document.querySelectorAll("a")
        links.forEach((link) => {
            link.addEventListener("click", handleLinkClick)
        })

        // Clean up event listeners when component unmounts
        return () => {
            links.forEach((link) => {
                link.removeEventListener("click", handleLinkClick)
            })
        }
        // eslint-disable-next-line
    }, [])

    const handleCloseButtonClick = () => {
        setIsExpanded(!isExpanded)
        handleHide()
    }

    const handleTouchStart = () => {
        setIsCloseButtonActive(true);
    };

    const handleTouchEnd = () => {
        setIsCloseButtonActive(false);
    };

    const isActive = (categoryValue) => {
        return selectedCategory === categoryValue
    }

    // return subtopic, course format and course level
    const getCourseSubtopic = () => {
        return (
            <>
                <FormatContainer style={{ borderBottom: "none" }}>
                    <CategoryContainer onClick={() => toggleSubtopic()}>
                        <VerticalH3>Course Topics</VerticalH3>

                        <ChevronContainer
                            style={{
                                transform: isSubtopicOpen ? "rotateZ(180deg)" : "none"
                            }}
                        >
                            <Chevron />
                        </ChevronContainer>

                    </CategoryContainer>
                    {isSubtopicOpen && categories[selectedCategory] !== null && <div>
                        {categories[selectedCategory].label_options.map((subcategory) => (
                            <VerticalTopicLink
                                isCoursesPage={true}
                                isActive={selectedSubcategory === subcategory.value}
                                style={{ cursor: "pointer" }} key={subcategory.value}
                                onClick={() =>
                                    onSubcategoryChange(subcategory)}>
                                {subcategory.label}</VerticalTopicLink>
                        ))}
                    </div>}
                </FormatContainer>
            </>
        )
    }

    const getCourseFormat = () => {
        return (
            <FormatContainer>
                <CategoryContainer onClick={() => toggleFormat()}>
                    <VerticalH3>Course Formats</VerticalH3>
                    <ChevronContainer
                        style={{
                            transform: isFormatOpen ? "rotateZ(180deg)" : "none"
                        }}
                    >
                        <Chevron />
                    </ChevronContainer>
                </CategoryContainer>
                {isFormatOpen &&
                    <div>
                        {availableFormats.map((format) => (
                            <VerticalTopicLink
                                isCoursesPage={true}
                                isActive={selectedFormat === format.value}
                                style={{
                                    cursor: "pointer"
                                }} options={availableFormats} onClick={() => {
                                    onFormatChange(format)
                                }}>{format.label}</VerticalTopicLink>

                        ))}
                    </div>}
            </FormatContainer>
        )
    }

    const getCourseLevel = () => {
        return (
            <>
                <CategoryContainer onClick={() => toggleCourseLevel()}>
                    <VerticalH3 isCourseLevelOpen={isCourseLevelOpen}>Course Levels</VerticalH3>
                    <ChevronContainer
                        style={{
                            transform: isCourseLevelOpen ? "rotateZ(180deg)" : "none"
                        }}
                    >
                        <Chevron />
                    </ChevronContainer>
                </CategoryContainer>
                {
                    isCourseLevelOpen &&
                    <>
                        <div>
                            {categories["all"]?.label_options.map((category) => (
                                <VerticalTopicLink
                                    isCoursesPage={true}
                                    isActive={selectedLevel === category.value}
                                    key={category.value}
                                    onClick={() => {
                                        onTopicChange(category)
                                    }}
                                    style={{
                                        cursor: "pointer",

                                    }}
                                >
                                    {category.label}
                                </VerticalTopicLink>
                            ))}
                        </div>
                    </>
                }

            </>

        )
    }

    return (
        <VerticalExplorerContainer
            isCoursesPage={true}
            isExpanded={isExpanded}
            style={{ position: "relative", marginTop: "0", marginBottom: "0", border: "none" }}
        >
            {isMobile && showButton && (
                <>
                    <ExpandFilters style={{ marginTop: "0" }} secondary
                        isButton
                        onClick={() => {
                            setIsExpanded(!isExpanded)
                            handleShow()
                        }}
                    >
                        <Filter />
                        Open Filters
                    </ExpandFilters>
                </>
            )}

            <>
                {isMobile ? (<><MobileFilterMenu><MenuGrid isVisible={isVisible}>
                    <MenuContainer>
                        <CloseButtonContainer
                            onTouchStart={handleTouchStart}
                            onTouchEnd={handleTouchEnd}
                            isCloseButtonActive={isCloseButtonActive}
                        >
                            <CloseButton
                                isCloseButtonActive={isCloseButtonActive}
                                onClick={handleCloseButtonClick}
                                onTouchStart={handleTouchStart}
                                onTouchEnd={handleTouchEnd}
                            >
                                <CloseChevron
                                    isCloseButtonActive={isCloseButtonActive}
                                    onClick={handleCloseButtonClick}
                                    onTouchStart={handleTouchStart}
                                    onTouchEnd={handleTouchEnd} />CLOSE</CloseButton> <FilteredCoursesTitle>Filter Courses:</FilteredCoursesTitle>
                        </CloseButtonContainer>
                        <MenuContent isSmallScreen={true}>
                            <CategoryContainer onClick={() => toggleTopic()}>
                                <VerticalH3
                                    style={{ paddingBottom: "20px", paddingRight: "10px" }}
                                    isCoursesPage={true}
                                    isTopicOpen={isTopicOpen}>Course Categories</VerticalH3>
                                <ChevronContainer
                                    style={{
                                        transform: isTopicOpen ? "rotateZ(180deg)" : "none",
                                        marginBottom: "7px"
                                    }}
                                >
                                    <Chevron />
                                </ChevronContainer>
                            </CategoryContainer>
                            {isTopicOpen && (
                                <>
                                    <TagsContainer>

                                        <div>{Object.values(categories).map((category) => (
                                            <VerticalTopicLink
                                                isSmallScreen={true}
                                                isCoursesPage={true}
                                                isActive={isActive(category.value)}
                                                style={{ cursor: "pointer", display: category.value === "build_with_ai" ? "flex" : "" }}
                                                key={category.value}
                                                onClick={() => handleTagClick(category)}
                                            >{category.label}{category.value === "build_with_ai" ? <NewTagCategory>NEW</NewTagCategory> : ""}</VerticalTopicLink>
                                        ))}
                                        </div>

                                    </TagsContainer>
                                </>
                            )}
                            {
                                isCategoryClicked &&
                                selectedCategory !== "all" &&
                                categories[selectedCategory]?.label_options?.length > 1 &&
                                (
                                    <>
                                        {getCourseSubtopic()}
                                    </>
                                )

                            }
                            {getCourseFormat()}
                            {getCourseLevel()}
                        </MenuContent>
                        <ApplyFiltersContainer style={{ bottom: "0", }}><ExpandFiltersButton

                            onClick={() => {
                                setIsExpanded(!isExpanded)
                                handleHide()
                            }}
                            secondary
                            isButton
                        >Apply Filters</ExpandFiltersButton></ApplyFiltersContainer>
                    </MenuContainer>
                </MenuGrid>
                    <MenuOverlay isVisible={isVisible} isActive={isCloseButtonActive}
                        onClick={handleCloseButtonClick} />
                </MobileFilterMenu>
                </>
                ) : (<>
                    {/* DESKTOP */}

                    <FilteredCoursesTitle>Filter Courses:</FilteredCoursesTitle>


                    <CategoryContainer onClick={() => toggleTopic()}>
                        <VerticalH3
                            style={{ paddingBottom: "20px", paddingRight: "10px" }}
                            isCoursesPage={true}
                            isTopicOpen={isTopicOpen}>Course Categories</VerticalH3>
                        <ChevronContainer
                            style={{
                                transform: isTopicOpen ? "rotateZ(180deg)" : "none",
                                marginBottom: "7px"
                            }}
                        >
                            <Chevron />
                        </ChevronContainer>
                    </CategoryContainer>

                    {isTopicOpen && (
                        <>
                            <TagsContainer>
                                {Object.values(categories).map((category) => (
                                    <CourseTag
                                        key={category.value}
                                        onClick={() => handleTagClick(category)}
                                        className={isActive(category.value) ? "active" : ""}
                                        isButton
                                        tag
                                    >
                                        {category.label} {category.value === "build_with_ai" ? <NewTagCategory>NEW</NewTagCategory> : ""}
                                    </CourseTag>
                                ))}

                            </TagsContainer>
                        </>
                    )}
                    {
                        isCategoryClicked &&
                        selectedCategory !== "all" &&
                        categories[selectedCategory]?.label_options?.length > 1 &&
                        (
                            <>
                                {getCourseSubtopic()}
                            </>
                        )

                    }

                    {getCourseFormat()}
                    {getCourseLevel()}
                </>)}
            </>
        </VerticalExplorerContainer >
    )
}

export default CourseFilter